Jelly.Payments.Update_Membership_Level = function (Parameters) {
	// Update yearly amount from monthly amount, discount
	console.log(Parameters);	

	// Determine discount
	var $Offer_Annual_Discount = $("input\[name=\"" + Parameters.Action_Namespace + "_Offer_Annual_Discount\"\]");
	var $Annual_Discount_Kind = $("input\[name=\"" + Parameters.Action_Namespace + "_Annual_Discount_Kind\"\]");
	var $Annual_Discount_Percent = $("input\[name=\"" + Parameters.Action_Namespace + "_Annual_Discount_Percent\"\]");
	var Discount = 0;
	if ($Offer_Annual_Discount.is(":checked") && $Annual_Discount_Kind.val() == "Percent" && $Annual_Discount_Percent.val()) {
		Discount = parseInt($Annual_Discount_Percent.val());
	}
	console.log($Offer_Annual_Discount.is(":checked"));
	console.log($Annual_Discount_Kind.val());
	console.log($Annual_Discount_Percent.val());
	console.log(Discount);

	// Apply discount to all relevant items
	if (Parameters.Namespace) {
		var $Membership_Iterator = $('#' + Parameters.Namespace + "_JS_Hook").closest(".Membership_Item");
	}
	else { 
		var $Membership_Iterator = $('#' + Parameters.Action_Namespace + ' .Membership_Item');
	}
	console.log($Membership_Iterator);

	$Membership_Iterator.each(function() {
		// Get membership namespace, etc.
		var $Membership_Item = $(this);
		console.log($Membership_Item);
		
		var Membership_Namespace = $Membership_Item.find(".JS_Hook").data("namespace");
		console.log(Membership_Namespace);

		// Get elements
		var $Weekly_Amount = $("#" + Membership_Namespace + " input\[name=\"" +  + "week_amount\"\]");
		var $Monthly_Amount = $("#" + Membership_Namespace + " input\[name=\"" +  + "month_amount\"\]");
		var $Annual_Amount = $("#" + Membership_Namespace + " input\[name=\"" +  + "year_amount\"\]");
		var $Discount_Display = $("#" + Membership_Namespace + "_Year_Amount_Discount_Hint");
		console.log($Discount_Display);

		// Update amounts
		switch (Parameters.Kind) {
			case "Weekly":
				// Normalize weekly value
				if ($Weekly_Amount.val() == "")
					$Weekly_Amount.val(0);

				// Update monthly + annual amounts
				$Monthly_Amount.val(Math.round($Weekly_Amount.val() * 4.34));
				$Annual_Amount.val(Math.round($Weekly_Amount.val() * 4.34 * 12));
				break;
			case "Monthly":
			case "Discount":
				// Update annual amount in field

				// Normalize monthly value
				if ($Monthly_Amount.val() == "")
					$Monthly_Amount.val(0);

				// Calculate annual value
				var Monthly_Amount = $Monthly_Amount.val();
				var Annual_Amount = Monthly_Amount * 12 * ((100 - Discount)/100);

				// Round annual value if monthly value was a whole number
				if (Monthly_Amount % 1 == 0) {
					Annual_Amount = Math.round(Annual_Amount);
				}
				else { 
					Annual_Amount = Math.round(Annual_Amount * 100) / 100;
				}

				// Update annual amount
				$Annual_Amount.val(Annual_Amount);
				
				// Update annual amount pre-discount for explainer...
				var Annual_Amount_Pre_Discount = Monthly_Amount * 12;

				// Round annual value pre discount if monthly value was a whole number
				if (Monthly_Amount % 1 == 0) {
					Annual_Amount_Pre_Discount = Math.round(Annual_Amount_Pre_Discount);
				}
				else { 
					Annual_Amount_Pre_Discount = Math.round(Annual_Amount_Pre_Discount * 100) / 100;
				}

				$Discount_Display.find('.Year_Amount_Pre_Discount').html(Annual_Amount_Pre_Discount);

				// Update discount display status
				if (Discount) { 
					$Discount_Display.show().find('.Discount_Amount').html(Discount)
				}
				else { 
					$Discount_Display.hide();
				}

				// Calculate weekly value
				if ($Weekly_Amount.length)
					$Weekly_Amount.val(Math.round($Monthly_Amount.val() / 4.34));
				break;

			case "Annual":
				// Update annual amount in field

				// Normalize annual value
				if ($Annual_Amount.val() == "")
					$Annual_Amount.val(0);

				// Calculate monthly value 
				var Annual_Amount = $Annual_Amount.val();
				var Monthly_Amount = $Annual_Amount.val() * ((100 + Discount)/100) / 12;

				// Round monthly monthly value if annual value was a whole number
				if (Annual_Amount % 1 == 0) {
					Monthly_Amount = Math.round(Monthly_Amount);
				}
				else { 
					Monthly_Amount = Math.round(Monthly_Amount * 100) / 100;
				}

				// Update monthly amount
				$Monthly_Amount.val(Monthly_Amount);

				// Update annual amount pre-discount for explainer...
				var Annual_Amount_Pre_Discount = (Annual_Amount * 100)/(100 - Discount);

				// Round annual value pre discount if annual value was a whole number
				if (Annual_Amount % 1 == 0) {
					Annual_Amount_Pre_Discount = Math.round(Annual_Amount_Pre_Discount);
				}
				else { 
					Annual_Amount_Pre_Discount = Math.round(Annual_Amount_Pre_Discount * 100) / 100;
				}

				// Update annual amount pre-discount for explainer
				$Discount_Display.find('.Year_Amount_Pre_Discount').html(Annual_Amount_Pre_Discount);
				
				// Update discount display status
				if (Discount) { 
					$Discount_Display.show().find('.Discount_Amount').html(Discount);
				}
				else { 
					$Discount_Display.hide();
				}

				// Calculate weekly value
				if ($Weekly_Amount.length)
					$Weekly_Amount.val(Math.round($Annual_Amount.val() / 12 / 4.34));
				break;
		}
	});
};